/**
 * AVAILABILITY CHECK DELIVERY DATE
 *
 * NOTE!
 * - the "start" date uses the `to` param because it means the calender is disabled UP TO that date.
 * - the "end" date uses the `from` param because it means the calendar is disabled FROM that
 *   date onward.
 *
 * - the last param `(]` refers to inclusivity of the dates (see moment.js @link above). It says
 *   "exclude the "start" date but include the "end" date.
 *
 * @link https://github.com/charliekassel/vuejs-datepicker#disabled-dates
 * @link https://momentjs.com/docs/#/query/is-between/
 */
import ErrorMessages from '@mymyTranslations/validation';
import moment from 'moment-timezone';
export default {
    params: ['disabledDates'],
    computesRequired: true,
    validate: ( selectedDate, args ) => {
        // is valid if the selected date is between the end of the `to` disabled date and the
        // beginning of the `from` disabled date (see notes and links to docs above).
        return {
            required: true,
            valid: moment(selectedDate).isBetween(moment(args.disabledDates.to), moment(args.disabledDates.from), 'days', '(]'),
        };
    },

    // error message
    message: (fieldName, args) => {
        return ErrorMessages[window.mymy.request.currentSite.language].messages['deliveryDate'];
    },
};